/*
 * @Author: cc
 * @Date: 2019-12-26 11:46:35
 * @LastEditTime: 2021-08-12 11:13:38
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\components\util\util.js
 * @Description: 指令模块主控
 */
'use strict';
angular.module('components.util', [
    'util.trsTDCheckModule',
    'util.dragdrop',
    'util.trsthumb',
    'util.trsScrollFixModule',
    'util.trsRadio',
    'util.trsSingleRadio',
    'util.trsSingleSelection',
    'util.trsEchartsModule',
    'util.trsWordNum',
    'util.JsonArrayToString',
    'util.httpService',
    'util.checkbox',
    'util.trsBigFaceModule',
    'util.trsLegendBigFaceModule', // 图集稿图说痕迹模块
    'util.trsLoginUserModule',
    'util.trsLeftMenu',
    'util.trsSliderModule',
    'util.trsDrag',
    'util.trslistIcon',
    'util.trsViewOriginalPic',
    'util.trsFinishRepeatModule',
    'trsPagenationConfigLeftModule',
    'trsPagenationConfigLeftCamelCaseModule',
    'trsPagenationConfigRightModule',
    'trsPersonalVideoUploadDirective',
    'webIMModule',

    /*  'trsScrollbar',*/
    'trsTimeSelectModule',
    'trsTimeDropDownModule',
    'trsContentEditableModule',
    'editingCenter.imgUploadChg',
    'trsPasteModule',
    'util.trsScrollPicturesModule',
    'util.trsWeChatEditorModule',
    'editingCenter.imgUploadChgWeibo',
    'util.trsAddToCreate',
    'util.ueditorForApp',
    'util.ueditorForCommand',
    'util.trsMultiSelection',
    'util.trsCascader',
    // 'coverGuideModule',
    'trsTooltipModule',
    'trsPositionFixedModule',
    'trsTreeScrollTopModule',
    'provinceAndCitiesModule',
    'util.trsMapScaleModule',
    'trsPreviewTitleModule',
    'publicFooterModule',
    'cascadingMenuModule',
    'util.trsSliderBarModule',
    'util.btnDisabled',
    'util.waterflow',
    'headerLogoModule',
    'formControlModule',
    'videoCanPlayModule',
    'pageFixPatchModule',
    'util.trsWordCountTextarea',
    'ngMousewheelModule',
    'dragScrollModule',
    'preciseTimePickerModule', // 精确时间选择器
    'util.ueditorForManuscript', // 广电广电文稿编辑器
    'colResizableModule', // 拖拽改变表格列宽
    'util.ueditorForNotice', // 公告编辑器
    'trsAudioVideoUploadModule', // 新疆云新增视频上传
    'imageTypeChangeService', // 图片转码处理
    'mediaSelectorModule', // 通用媒资库素材选择模块
    'autoPicModule', // 图集模式
    'util.MapModule', // 地图模块
    'listCardModule',
    'trsPlayAudioVideoModule', // 查看页音视频播放组件
    'util.colorPicker', // 颜色选择器
    'typeHeadModule',
    'trsAudioVideoDraftModule', 
    'trsUploadForXjModule',
    'util.trsFrame', // frame
    'uploadAttachmentModule', // 通用上传弹窗模块
]);
